
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, MessageSquare, FileText } from "lucide-react";

// Mock data
const supplierData = [
  {
    id: 1,
    name: "EcoFarms",
    totalProducts: 24,
    inventoryValue: 4580.00,
    returnableStock: 3,
    restockRecommendation: "Medium",
    creditTerms: "Net 30"
  },
  {
    id: 2,
    name: "Dairy Fresh",
    totalProducts: 18,
    inventoryValue: 2980.00,
    returnableStock: 5,
    restockRecommendation: "High",
    creditTerms: "COD"
  },
  {
    id: 3,
    name: "Healthy Bakery",
    totalProducts: 12,
    inventoryValue: 1250.00,
    returnableStock: 0,
    restockRecommendation: "Low",
    creditTerms: "Net 15"
  },
  {
    id: 4,
    name: "Happy Farms",
    totalProducts: 8,
    inventoryValue: 980.00,
    returnableStock: 2,
    restockRecommendation: "Medium",
    creditTerms: "Net 30"
  },
  {
    id: 5,
    name: "BeanMaster",
    totalProducts: 15,
    inventoryValue: 3450.00,
    returnableStock: 0,
    restockRecommendation: "Low",
    creditTerms: "Net 45"
  }
];

const SupplierStockViewTab = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTermFilter, setSelectedTermFilter] = useState("all");
  
  const filteredSupplierData = supplierData
    .filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .filter(item => selectedTermFilter === "all" || item.creditTerms.includes(selectedTermFilter));
  
  const getRecommendationClass = (recommendation: string) => {
    switch (recommendation.toLowerCase()) {
      case "high":
        return "text-red-600 font-medium";
      case "medium":
        return "text-yellow-600 font-medium";
      case "low":
        return "text-green-600 font-medium";
      default:
        return "";
    }
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Supplier Stock View</h2>
        <div className="flex gap-2">
          <select 
            className="rounded border px-2.5 py-1.5"
            value={selectedTermFilter}
            onChange={(e) => setSelectedTermFilter(e.target.value)}
          >
            <option value="all">All Payment Terms</option>
            <option value="COD">COD</option>
            <option value="Net 15">Net 15</option>
            <option value="Net 30">Net 30</option>
            <option value="Net 45">Net 45</option>
          </select>
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search suppliers..."
              className="pl-8 w-[250px]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button variant="outline">
            <FileText className="mr-2 h-4 w-4" />
            Export
          </Button>
        </div>
      </div>
      
      <div className="border rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Supplier Name</TableHead>
              <TableHead className="text-center">Total Products</TableHead>
              <TableHead className="text-right">Inventory Value</TableHead>
              <TableHead className="text-center">Returnable Stock</TableHead>
              <TableHead>Restock Recommendation</TableHead>
              <TableHead>Credit Terms</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredSupplierData.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-medium">{item.name}</TableCell>
                <TableCell className="text-center">{item.totalProducts}</TableCell>
                <TableCell className="text-right">RM {item.inventoryValue.toFixed(2)}</TableCell>
                <TableCell className="text-center">{item.returnableStock}</TableCell>
                <TableCell className={getRecommendationClass(item.restockRecommendation)}>
                  {item.restockRecommendation}
                </TableCell>
                <TableCell>{item.creditTerms}</TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="outline" className="mr-2">
                    <MessageSquare className="h-4 w-4 mr-1" />
                    Contact
                  </Button>
                  <Button size="sm">View Stock</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default SupplierStockViewTab;
